import { Component, OnInit } from '@angular/core';
import { WebApiObservableService } from 'app/web-api-observable/web-api-observable.service';
//import { MetaService } from 'ng2-meta';
import { NgxCarousel } from 'ngx-carousel';
import { FoodServiceService } from 'app/food-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {
  public carouselBannerItems: Array<any>;
  public carouselBanner: NgxCarousel;
  foods: any[] = [];
  tabs = [{
    href: '#h1-tab-products-1',
    title: 'Wraps',
    class: ''
  }, {
    href: '#h1-tab-products-2',
    title: 'Pizza Sets',
    class: 'active'
  }, {
    href: '#h1-tab-products-3',
    title: 'Burgers',
    class: ''
  }];
  categories: any[] = [];
  catogoryidforfood = '';
  sectiontabs = [];
  searchparams = {
    status: 1
  };
  errorMessage = [];
  wraps = [{
    image: 'assets/images/p1.jpg',
    title: 'Pepperoni Pizza',
    para: 'Extra-virgin olive oil, garlic, mozzarella, mushrooms and olives.',
    size1: '22',
    size2: '29',
    price1: '19',
    price2: '25'
  },
  {
    image: 'assets/images/p2.jpg',
    title: 'Trio Cheese',
    para: 'Extra-virgin olive oil, garlic, mozzarella, mushrooms and olives.',
    size1: '22',
    size2: '29',
    price1: '19',
    price2: '25'
  },
  {
    image: 'assets/images/p3.jpg',
    title: 'Apricot Chicken',
    para: 'Extra-virgin olive oil, garlic, mozzarella, mushrooms and olives.',
    size1: '22',
    size2: '29',
    price1: '19',
    price2: '25'
  }];

  pizzaArray = [{
    image: 'assets/images/p4.jpg',
    title: 'Italiano Original',
    para: 'Extra-virgin olive oil, garlic, mozzarella, mushrooms and olives.',
    size1: '22',
    size2: '29',
    price1: '19',
    price2: '25'
  },
  {
    image: 'assets/images/p5.jpg',
    title: 'Chicken Hawaii',
    para: 'Extra-virgin olive oil, garlic, mozzarella, mushrooms and olives.',
    size1: '22',
    size2: '29',
    price1: '19',
    price2: '25'
  },
  {
    image: 'assets/images/p6.jpg',
    title: 'Summer Pizza',
    para: 'Extra-virgin olive oil, garlic, mozzarella, mushrooms and olives.',
    size1: '22',
    size2: '29',
    price1: '19',
    price2: '25'
  }];

  burgers = [{
    image: 'assets/images/p7.jpg',
    title: 'Pepperoni Calzone',
    para: 'Extra-virgin olive oil, garlic, mozzarella, mushrooms and olives.',
    size1: '22',
    size2: '29',
    price1: '19',
    price2: '25'
  },
  {
    image: 'assets/images/p8.jpg',
    title: 'Pepperoni Pizza',
    para: 'Extra-virgin olive oil, garlic, mozzarella, mushrooms and olives.',
    size1: '22',
    size2: '29',
    price1: '19',
    price2: '25'
  },
  {
    image: 'assets/images/p9.jpg',
    title: 'Trio Cheese',
    para: 'Extra-virgin olive oil, garlic, mozzarella, mushrooms and olives.',
    size1: '22',
    size2: '29',
    price1: '19',
    price2: '25'
  }];
  //private metaService: MetaService,
  constructor(private CommonService: WebApiObservableService, private _Food: FoodServiceService, private router: Router) {

  }

  ngOnInit() {
    //this.carouselBannerItems = ['assets/images/foods/food3.jpg','assets/images/foods/food4.jpg','assets/images/foods/food.jpg','assets/images/foods/food2.jpg'];

    this.carouselBanner = {
      grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
      slide: 1,
      speed: 400,
      interval: 2000,
      point: true,
      load: 2,
      loop: true,
      custom: 'banner',
      touch: true
    }
    $('.spin').addClass('loading');
    this.CommonService
      .getSlidersService('/sliders/search?status=1')
      .subscribe(
      result => this.carouselBannerItems = result.items,
      error => this.errorMessage = <any>error
      );


    /*Calling Api for Categories */
    this.CommonService
      .getServiceForSearch('/categories', 'status', '10')
      .subscribe(
      result => this.categories = result.items,
      error => this.errorMessage = <any>error
      );

    this.CommonService
      .getServiceWithComplexObjectAsQueryString('/categories', this.searchparams)
      .subscribe(
      result => {
        this.sectiontabs = result.items; $('.spin').removeClass('loading');
        $('#section_' + this.sectiontabs[0].id).addClass('active');
        this._Food.
          getFoods(this.sectiontabs[0].id)
          .subscribe(
          result => { this.foods = result.items; console.log(this.foods) },
          error => { $('.spin').removeClass('loading'); this.foods = <any>error }
          );


      },
      error => { $('.spin').removeClass('loading'); this.errorMessage = <any>error }
      );

    this.loadScript('assets/js/jquery.min.js');
    this.loadScript('assets/js/owl.carousel.min.js');
    this.loadScript('assets/js/jquery.mCustomScrollbar.concat.min.js');
    this.loadScript('assets/js/scripts.min.js');

  }
  ngAfterViewInit() {
    this.loadScript('assets/js/jquery.min.js');
    this.loadScript('assets/js/owl.carousel.min.js');
    this.loadScript('assets/js/jquery.mCustomScrollbar.concat.min.js');
    this.loadScript('assets/js/scripts.min.js');

  }
  public loadScript(url) {

    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    document.getElementsByTagName('owl')[0].appendChild(node);
  }

  public carouselBannerLoad(evt: any) {

    const len = this.carouselBannerItems.length;
    if (len < 5) {
      for (let i = len; i < len; i++) {
        this.carouselBannerItems.push(i);
      }
    }

  }

  openFoods(id) {

    this._Food.
      getFoods(id)
      .subscribe(
      result => { this.foods = result.items; console.log(this.foods) },
      error => { $('.spin').removeClass('loading'); this.foods = <any>error }
      );
  }

  openOrderOnlinePage(id) {
    this.router.navigate(["order-online", id])
  }

  /*Function definition for Filters foods according to category id*/
  onCall(id) {
    this.catogoryidforfood = id;
    this.router.navigate(["order-online", id])
  }

}




// WEBPACK FOOTER //
// D:/deliverproject/eatasiafood/src/app/home/home.component.ts